"use strict";
exports.__esModule = true;
exports.toPodcast = void 0;
var utils_1 = require("@lglp/utils");
var fields_1 = require("../fields");
var toPodcast = function (data, logger) {
    var _a;
    var prismicPodcast = utils_1.unprefix('podcast', data);
    if (prismicPodcast) {
        var podcastSrc = logger.required(fields_1.toText((_a = prismicPodcast.src) === null || _a === void 0 ? void 0 : _a.url));
        if (!podcastSrc) {
            return undefined;
        }
        return utils_1.compact({
            src: podcastSrc,
            transcription: fields_1.toRichText(prismicPodcast.transcription, logger)
        });
    }
};
exports.toPodcast = toPodcast;
//# sourceMappingURL=podcast.js.map